import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, useScroll, useSpring, AnimatePresence } from 'framer-motion';

// Components
import Navbar from './components/common/Navbar';
import Footer from './components/sections/Footer';
import WhatsAppIcon from './components/common/WhatsAppIcon';
import Home from './pages/Home';
import About from './pages/About';
import ProductsPage from './pages/ProductsPage';
import Contact from './pages/Contact';
import ProductDetail from './components/sections/ProductDetail';

function App() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    if (selectedProduct) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [selectedProduct]);


  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  const handleShowDetail = (product) => {
    setSelectedProduct(product);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBackHome = () => {
    setSelectedProduct(null);
    window.history.back();
  };

  return (
    <Router>
      <div className="bg-[#0A0A0A] text-white selection:bg-primary/30 selection:text-primary-light font-body">
        {/* Scroll Progress Bar */}
        <motion.div
          className="fixed top-0 left-0 right-0 h-1 bg-primary z-[60] origin-left"
          style={{ scaleX }}
        />

        {/* Global Components */}
        <Navbar />
        <WhatsAppIcon phoneNumber="7621846829" />

        <AnimatePresence mode="wait">
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<Home onShowDetail={handleShowDetail} />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<ProductsPage onShowDetail={handleShowDetail} />} />
            <Route path="/contact" element={<Contact />} />

            {/* Detail View simulated via state as before - or can be moved to route */}
          </Routes>
        </AnimatePresence>

        {/* Product Detail Overlay if product is selected */}
        <AnimatePresence>
          {selectedProduct && (
            <motion.div
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.98 }}
              transition={{ duration: 0.4 }}
              className="fixed inset-0 z-[70] bg-[#0A0A0A] overflow-y-auto"
            >
              <ProductDetail product={selectedProduct} onBack={() => setSelectedProduct(null)} />
            </motion.div>
          )}
        </AnimatePresence>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
